import React from "react";
import { BACKEND } from "@/lib/api";

export default function Settings() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Ayarlar</h1>
        <p className="text-sm text-muted-foreground mt-1">Sistem bilgileri ve agent kurulum bilgileri</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="border border-border bg-card rounded-md p-4">
          <h2 className="text-sm font-semibold mb-3">Panel Bilgisi</h2>
          <div className="space-y-1.5 text-sm">
            <div className="flex justify-between"><span className="text-muted-foreground">Backend URL</span><span className="font-mono text-xs">{BACKEND}</span></div>
            <div className="flex justify-between"><span className="text-muted-foreground">Versiyon</span><span className="font-mono text-xs">1.0.0</span></div>
            <div className="flex justify-between"><span className="text-muted-foreground">Veritabanı</span><span className="font-mono text-xs">MariaDB</span></div>
          </div>
        </div>

        <div className="border border-border bg-card rounded-md p-4">
          <h2 className="text-sm font-semibold mb-3">Agent Mimarisi</h2>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li>• inotify ile <span className="font-mono text-foreground">/var/named</span> izlenir</li>
            <li>• WHM <span className="font-mono text-foreground">postwwwacct</span> + <span className="font-mono text-foreground">postkillacct</span> hook'ları yüklenir</li>
            <li>• <span className="font-mono text-foreground">127.0.0.1:8585</span> lokal HTTP listener</li>
            <li>• Debounce: 4 saniye · Heartbeat: 30 saniye</li>
            <li>• systemd servis: <span className="font-mono text-foreground">netlen-dns-agent</span></li>
          </ul>
        </div>
      </div>

      <div className="border border-border bg-card rounded-md p-4">
        <h2 className="text-sm font-semibold mb-3">Senkron Stratejisi</h2>
        <div className="text-sm text-muted-foreground space-y-2">
          <p>Full-replace zone sync — her değişiklikte domain için güncel tüm RRSet'ler PowerDNS'e PATCH ile yazılır. Diff motoru yerine tam durum gönderimi tercih edilmiştir (record silme/rename edge-case'lerini temizce çözer).</p>
          <p>
            <span className="font-mono text-foreground">Retry</span>: 10s → 30s → 60s → 5dk → 15dk → 1h → failed.
            Başarısız iş eşiği aşılırsa aktif alıcılara e-posta alert'i gider.
          </p>
          <p>
            <span className="font-mono text-foreground">Sağlık kontrolü</span>: 45 saniyede bir tüm PDNS'e /api/v1/servers/{"{id}"} GET atılır, zone sayısı ve versiyon kayıt edilir. WHM agent'ların heartbeat'i 3 dakikadan eski ise "çevrimdışı" işaretlenir.
          </p>
        </div>
      </div>
    </div>
  );
}
